import React, { ComponentProps } from 'react';
import { BreadcrumbDefaultView, BreadcrumbDefaultViewProps } from './views/BreadcrumbDefaultView';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { BlockGuard } from '../../types/api/Block';

export type BreadcrumbProps = Views<DefaultView<BreadcrumbDefaultViewProps>>;
export function Breadcrumb(props: BreadcrumbProps) {
  return <BreadcrumbDefaultView {...props.views.default} />;
}

export const BreadcrumbBlock = asBlock(Breadcrumb, BlockType.breadcrumb);
export type BreadcrumbBlock = ComponentProps<typeof BreadcrumbBlock>;
export const isBreadcrumbBlock = BlockGuard<BreadcrumbBlock>(BlockType.breadcrumb);
